import {
  AbsoluteFill,
  Audio,
  Sequence,
  staticFile,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { pieces } from "./layout";
import { packingSvg } from "./scene";

export const LastPiece: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  return (
    <AbsoluteFill style={{ backgroundColor: "#0B1020" }}>
      {pieces
        .filter((p) => p.land !== undefined)
        .map((p) => (
          <Sequence
            key={p.id}
            from={Math.round(p.land! * fps)}
            durationInFrames={Math.ceil(0.2 * fps)}
            premountFor={fps}
          >
            <Audio
              src={staticFile(
                p.id === "E" ? "packing/finish.wav" : "packing/click.wav",
              )}
            />
          </Sequence>
        ))}
      <div dangerouslySetInnerHTML={{ __html: packingSvg(frame / fps) }} />
    </AbsoluteFill>
  );
};
